import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { EformsSubjectService } from '../../../formulaires/eforms/services/eforms-subject.service';
import { MotifModificationMessages } from '../../../shared/models/component-messages/motif-modification';

@Component({
	selector: 'app-popup-change',
	templateUrl: './popup-change.component.html'
})
export class PopupChangeComponent implements OnInit {

	@Output() motif: EventEmitter<String> = new EventEmitter();

	public motifModificationMessages = new MotifModificationMessages();
	public form: FormGroup;
	public optionsSelect: any[] = [];

	constructor(public modalService: NgbModal, private activeModal: NgbActiveModal, private eformsSubjectService :EformsSubjectService, private translateService: TranslateService) { }

	public ngOnInit() {
		this.form = new FormGroup({});
		this.optionsSelect = this.eformsSubjectService.changeCorrigJustification.getValue();
	}

	exit(){
		this.activeModal.close();
	}

	valider() {
		this.motif.emit(this.form.get('motif').value);
		this.exit()
	}
}
